export const USER_MANAGEMENT = 'userManagement'

export const userManagementTranslation = {
  en: {
    translation: {
      [USER_MANAGEMENT]: {
        table: {
          email: 'Email',
          firstName: 'First Name',
          lastName: 'Last Name',
          account: 'Account',
          language: 'Language',
          status: 'Status',
          createdDate: 'Created Date',
          modifiedBy: 'Modified By',
          modifiedDate: 'Modified Date',
          users: 'Users',
        },
        modal: {
          vendorManagerUser: 'Vendor Manager User',
          newUser: 'New User',
          addUser: 'Add User',
          id: 'ID',
          email: 'Email',
          firstName: 'First Name',
          lastName: 'Last Name',
          password: 'Password',
          passwordStrength: 'Password Strength',
          accountType: 'Account Type',
          language: 'Language',
          activated: 'Activated',
          newBonus: 'Bonus',
          newTarget: 'Target',
          ignoreQuota: 'Ignore Performance',
          address: 'Address',
          city: 'City',
          state: 'State',
          markets: 'Markets',
          regions: 'Regions',
          zipcode: 'Zip code',
          telephone: 'Telephone',
          ext: 'Ext',
          employeeID: 'Employee ID',
          fieldProjectManagerRole: 'Field Manager Role',
          managerRole: 'Manager Role',
          parentFieldProjectManagerId: 'Manager',
          save: 'Save',
          cancel: 'Cancel',
          delete: 'Delete',
          deleteUserContent: 'Do you really want to delete this user?',
          deleteUserModal: 'Delete User',
          deleteUserSuccess: 'User Deleted Succesfully',
          deleteUserFailed: 'Unable to Delete User!',
          addUserSuccess: 'User has been added successfully',
          updateUser: 'User Update',
          updateUserSuccess: 'User Updated Successfully',
          userUpdateFailed: 'Unable to Update User!',
          userAddFailed: 'Unable to Add User!',
        },
      },
    },
  },
  es: {
    translation: {
      [USER_MANAGEMENT]: {
        table: {
          email: 'Correo electrónico',
          firstName: 'Primer nombre',
          lastName: 'Apellido',
          account: 'Cuenta',
          language: 'Idioma',
          status: 'Estado',
          createdDate: 'Fecha de creación',
          modifiedBy: 'Modificado por',
          modifiedDate: 'Fecha de modificación',
          user: 'Usuaria',
        },
        modal: {
          vendorManagerUser: 'Usuario administrador de proveedores',
          newUser: 'Nueva usuaria',
          addUser: 'Agregar usuario',
          id: 'IDENTIFICACIÓN',
          email: 'Correo electrónico',
          firstName: 'Primer nombre',
          lastName: 'Apellido',
          password: 'Clave',
          passwordStrength: 'seguridad de la contraseña',
          accountType: 'Tipo de cuenta',
          language: 'Idioma',
          activated: 'Activada',
          newBonus: 'Prima',
          newTarget: 'Objectivo',
          ignoreQuota: 'Ignorar rendimiento',
          address: 'Dirección',
          city: 'Ciudad',
          state: 'Estado',
          markets: 'Mercados',
          regions: 'Regiones',
          zipcode: 'Código postal',
          telephone: 'Teléfono',
          ext: 'Ext.',
          employeeID: 'ID de empleado',
          fieldProjectManagerRole: 'Field Manager Role',
          managerRole: 'Manager Role',
          parentFieldProjectManagerId: 'Manager',
          save: 'Ahorrar',
          cancel: 'cancelar',
          delete: 'Borrar',
          deleteUserContent: '¿Realmente quieres eliminar a este usuario?',
          deleteUserModal: 'Borrar usuario',
          deleteUserSuccess: 'Usuario eliminado con éxito',
          deleteUserFailed: '¡No se puede eliminar el usuario!',
          addUserSuccess: 'El usuario ha sido agregado con éxito',
          updateUser: 'Actualización de usuario',
          updateUserSuccess: 'Usuario actualizado con éxito',
          userUpdateFailed: '¡No se puede actualizar el usuario!',
        },
      },
    },
  },
}
